import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-full",
  "use": "icon-full-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-full\"><path d=\"M704 64h256v64h-256z\" p-id=\"6756\" /><path d=\"M896 64h64v256h-64zM66.688 64h64v256h-64z\" p-id=\"6757\" /><path d=\"M66.688 64h256v64h-256zM66.688 894.976h256v64h-256z\" p-id=\"6758\" /><path d=\"M66.688 702.976h64v256h-64zM896 702.976h64v256h-64z\" p-id=\"6759\" /><path d=\"M704 894.976h256v64h-256z\" p-id=\"6760\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol